// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"iX-z","sponsoredTooltipWrapper":"jX-z","sponsoredTooltip":"kX-z","newCard":"lX-z"};